import api from "./api";

export const getServiceGroups = async () => {
    try {
        const res = await api.get("/api/service-groups", { params: { size: 9999 } });
        const responseData = res?.data;
        return Array.isArray(responseData) ? responseData : (responseData?.content || responseData?.items || responseData?.data || []);
    } catch (error) {
        console.error("Error fetching service groups:", error);
        return [];
    }
};

// Frontend workaround: fetch detail for each group to get missing fields (slug, description)
export const getServiceGroupsFull = async () => {
    try {
        const summaries = await getServiceGroups();
        const activeSummaries = summaries.filter(g => g.isActive !== false);
        
        const fullGroups = await Promise.all(activeSummaries.map(async (g) => {
            try {
                const res = await api.get(`/api/service-groups/${g.id || g._id}`);
                return res.data;
            } catch (err) {
                console.warn(`Could not fetch details for group ${g.name}`, err);
                // Fallback: create slug from name if missing
                if (!g.slug) {
                    g.slug = g.name.toLowerCase()
                        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                        .replace(/[đĐ]/g, "d")
                        .replace(/[^a-z0-9]/g, "-")
                        .replace(/-+/g, "-")
                        .replace(/^-|-$/g, "");
                }
                return g;
            }
        }));
        return fullGroups;
    } catch (error) {
        console.error("Error fetching full service groups:", error);
        return [];
    }
};

export const getServiceItems = async () => {
    try {
        const res = await api.get("/api/service-items", { params: { size: 9999 } });
        const responseData = res?.data;
        return Array.isArray(responseData) ? responseData : (responseData?.content || responseData?.items || responseData?.data || []);
    } catch (error) {
        console.error("Error fetching service items:", error);
        return [];
    }
};

export const getServiceItemById = async (id) => {
    try {
        const res = await api.get(`/api/service-items/${id}`);
        return res?.data || null;
    } catch (error) {
        console.error("Error fetching service item detail:", error);
        return null;
    }
};

export const getServiceItemsByGroup = async (groupName) => {
    try {
        const nameEncoded = window.encodeURIComponent(groupName);
        const res = await api.get(`/api/service-items/${nameEncoded}/items`, { params: { size: 9999 } });
        return Array.isArray(res?.data) ? res.data : [];
    } catch (error) {
        console.error("Error fetching service items for group:", error);
        return [];
    }
};

export const searchServices = async (query) => {
    try {
        const res = await api.get("/api/service-items/search", { params: { q: query, size: 20 } });
        const responseData = res?.data;
        return Array.isArray(responseData) ? responseData : (responseData?.content || responseData?.items || responseData?.data || []);
    } catch (error) {
        console.error("Error searching services:", error);
        return [];
    }
};

export const getServiceTitles = async () => {
    try {
        const res = await api.get('/api/service-items', { params: { size: 9999 } });
        return Array.isArray(res?.data) ? res.data : (res?.data?.items || res?.data?.content || []);
    } catch (error) {
        console.error('Error fetching service titles:', error);
        return [];
    }
};
